export default __webpack_public_path__ + "static/media/steven_logo.cb12ceec.webp";